import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import { RepeatOneSharp } from "@material-ui/icons";

export const ConfigProduccion = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const chkPAnu = useRef();
  const chkPTri = useRef();
  const chkPMen = useRef();
  const chkPDAnu = useRef();
  const chkPDTri = useRef();
  const chkPDMen = useRef();
  const chkPDQuin = useRef();
  const chk1 = useRef();
  const chk2 = useRef();
  const chk3 = useRef();
  const chk4 = useRef();
  const chk5 = useRef();
  const chk6 = useRef();
  const chk100 = useRef();
  const chk1000 = useRef();
  const chkFijo = useRef();
  const chkSegun = useRef();
  const chkDwebsi = useRef();
  const chkDwebno = useRef();
  const txtRecargo = useRef();
  const chkk1 = useRef();
  const chkk2 = useRef();
  const chkk3 = useRef();
  const chkk4 = useRef();
  const chkk5 = useRef();
  const chkk6 = useRef();
  const chkmes1 = useRef();
  const chkmes2 = useRef();
  const chkmes3 = useRef();
  const chkmes4 = useRef();
  const chkmes5 = useRef();
  const chkmes6 = useRef();
  const chkmes7 = useRef();
  const chkmes8 = useRef();
  const chkmes9 = useRef();
  const chkmes10 = useRef();
  const chkmes11 = useRef();
  const chkmes12 = useRef();
  const txtDiDlecRegular = useRef();
  const txtDiLimit = useRef();
  const cmbDecla = useRef();
  const txtQuin1 = useRef();
  const txtQuin2 = useRef();
  const txtValor = useRef();
  const chkMininsi = useRef();
  const chkMininno = useRef();
  const txtPorcenInt = useRef();
  const [activate, setActivate] = useState(false);
  const [msg, setMsg] = useState();
  const [mostrar3, setMostrar3] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [operacionPer, setOperacionPer] = useState(0);
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [disabledInt, setDisabledInt] = useState(false);
  const [values, setValues] = useState({
    periodopago: "",
    periododeclaracion: "",
    factorcalculo: "",
    valorporcentual: "",
    tipointeres: "",
    porcentajeinteres: "",
    porcentajerecargo: "",
    ptoimpre: "",
    diavendeuda: "",
    factormulta: "",
    valormulta: "",
    diavendeudareg: "",
    diavendeudaq1: "",
    diavendeudaq2: "",
    mesdesdequincena: "",
    porcenimpuesto: "",
    aniodesdequincena: "",
    calculaminimo: "",
    declaraweb: "",
  });

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const onChange = (event) => {
    if (event.target.name === "tipointeres") {
      if (event.target.value !== "1") {
        setDisabledInt(true);
        txtPorcenInt.current.value = "0,00";
      } else if (event.target.value !== "2") {
        setDisabledInt(false);
        txtPorcenInt.current.focus();
        txtPorcenInt.current.value = formatMoneda(
          values.porcentajeinteres.replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }

      setValues({ ...values, [event.target.name]: event.target.value });
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  //console.log(values);

  const seleccionarConfiguracion = () => {
    let nomtab = "configproduccion";

    let endpoint = `${op.conexion}/api/consulta/config?nomtab=${nomtab}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        setValues(response.data);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/consulta/actualizarconfiguracion`;
    let body;
    setActivate(true);

    body = {
      tipoconf: 2,
      periodop: parseInt(values.periodopago),
      periodod: parseInt(values.periododeclaracion),
      factorcal: parseInt(values.factorcalculo),
      valorporcent: parseInt(values.valorporcentual),
      tipoint: parseInt(values.tipointeres),
      porcentajeint: parseFloat(
        txtPorcenInt.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      porcentajerec: parseFloat(
        txtRecargo.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      ptoimp: null,
      diavendeu: null,
      factormult: parseInt(values.factormulta),
      valormult: parseFloat(
        txtValor.current.value.replace(/\./g, "").replace(",", ".")
      ),
      diavendeureg: null,
      diavendeuq1: null,
      diavendeuq2: null,
      mesdesdequin: null,
      porcenimp: null,
      aniodesdequin: null,
      calculamin: chkMininsi.current.checked ? true : false,
      declaweb: chkDwebsi.current.checked ? true : false,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          seleccionarConfiguracion();

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro modificado correctamente",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setActivate(false);
  };

  const handleInputMontoChange = (event) => {
    console.log(event.target.value);
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const catalogoPer = () => {
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Desea Guardar los Cambios",
      icono: "confirmacion",
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    blanquear();
  };

  useEffect(() => {
    seleccionarConfiguracion();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Configuración del Modulo Producción</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <div className="container-fluid  rounded row mx-auto">
          <div className="col-md-5">
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Periódo de Pago
              </legend>
              <div className="form-check col-md-3 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="periodopago"
                  name="periodopago"
                  value={1}
                  defaultChecked={values.periodopago === 1 ? true : false}
                  ref={chkPAnu}
                  onChange={onChange}
                />
                <label className="form-check-label ">Anual</label>
              </div>
              <div className="form-check col-md-3 pl-0 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="periodopago"
                  name="periodopago"
                  value={2}
                  defaultChecked={values.periodopago === 2 ? true : false}
                  ref={chkPTri}
                  onChange={onChange}
                />
                <label className="form-check-label ">Trimestral</label>
              </div>
              <div className="form-check col-md-3 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="periodopago"
                  name="periodopago"
                  value={3}
                  defaultChecked={values.periodopago === 3 ? true : false}
                  ref={chkPMen}
                  onChange={onChange}
                />
                <label className="form-check-label ">Mensual</label>
              </div>
            </fieldset>
          </div>
          <div className="col-md-7">
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Periódo de Declaración
              </legend>
              <div className="form-check col-md-2 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="periododeclaracion"
                  value={1}
                  defaultChecked={
                    values.periododeclaracion === 1 ? true : false
                  }
                  name="periododeclaracion"
                  ref={chkPDAnu}
                  onChange={onChange}
                />
                <label className="form-check-label ">Anual</label>
              </div>
              <div className="form-check col-md-2 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="periododeclaracion"
                  value={2}
                  defaultChecked={
                    values.periododeclaracion === 2 ? true : false
                  }
                  name="periododeclaracion"
                  ref={chkPDTri}
                  onChange={onChange}
                />
                <label className="form-check-label ">Trimestral</label>
              </div>
              <div className="form-check col-md-2 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="periododeclaracion"
                  value={3}
                  defaultChecked={
                    values.periododeclaracion === 3 ? true : false
                  }
                  name="periododeclaracion"
                  ref={chkPDMen}
                  onChange={onChange}
                />
                <label className="form-check-label ">Mensual</label>
              </div>
              <div
                className="form-check col-md-2 mx-auto"
                style={{ visibility: "collapse" }}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  id="periododeclaracion"
                  value={4}
                  defaultChecked={
                    values.periododeclaracion === 4 ? true : false
                  }
                  name="periododeclaracion"
                  ref={chkPDQuin}
                  onChange={onChange}
                />
                <label className="form-check-label ">Quincenal</label>
              </div>
            </fieldset>
          </div>
          <div className="col-md-7">
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded pl-3">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Factor para el Cálculo del Minimo Tributable
              </legend>
              <div className="form-check col-md-4 mx-auto  mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factorcalculo"
                  name="factorcalculo"
                  value={1}
                  defaultChecked={values.factorcalculo === 1 ? true : false}
                  ref={chk1}
                  onChange={onChange}
                />
                <label className="form-check-label ">Bolivares(Bs.)</label>
              </div>
              <div className="form-check col-md-5 mx-auto  mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factorcalculo"
                  name="factorcalculo"
                  value={2}
                  defaultChecked={values.factorcalculo === 2 ? true : false}
                  ref={chk2}
                  onChange={onChange}
                />
                <label className="form-check-label ">
                  Unidades Tributarias
                </label>
              </div>
              <div className="form-check col-md-2 mx-auto  mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factorcalculo"
                  name="factorcalculo"
                  value={5}
                  defaultChecked={values.factorcalculo === 5 ? true : false}
                  ref={chk5}
                  onChange={onChange}
                />
                <label className="form-check-label ">UCAMP</label>
              </div>
              <div className="form-check col-md-5 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factorcalculo"
                  name="factorcalculo"
                  value={3}
                  defaultChecked={values.factorcalculo === 3 ? true : false}
                  ref={chk3}
                  onChange={onChange}
                />
                <label className="form-check-label ">Unidad Contable</label>
              </div>
              <div className="form-check col-md-4 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factorcalculo"
                  name="factorcalculo"
                  value={4}
                  defaultChecked={values.factorcalculo === 4 ? true : false}
                  ref={chk4}
                  onChange={onChange}
                />
                <label className="form-check-label ">Sueldo Minimo</label>
              </div>
              <div className="form-check col-md-2 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factorcalculo"
                  name="factorcalculo"
                  value={6}
                  defaultChecked={values.factorcalculo === 6 ? true : false}
                  ref={chk6}
                  onChange={onChange}
                />
                <label className="form-check-label ">Otros</label>
              </div>
            </fieldset>
          </div>
          <div className="col-md-5 py-1">
            <fieldset className=" row mt-2 py-3 col-sm-12 mx-auto border-azul rounded ">
              <span className="col-md-5">Valor Porcentual Alicuota</span>
              <div className="form-check col-md-3 ml-4 py-1">
                <input
                  className="form-check-input"
                  type="radio"
                  id="valorporcentual"
                  name="valorporcentual"
                  value={1}
                  defaultChecked={values.valorporcentual === 1 ? true : false}
                  ref={chk100}
                  onChange={onChange}
                />
                <label className="form-check-label py-1">100</label>
              </div>
              <div className="form-check col-md-3 py-1">
                <input
                  className="form-check-input"
                  type="radio"
                  id="valorporcentual"
                  name="valorporcentual"
                  value={2}
                  defaultChecked={values.valorporcentual === 2 ? true : false}
                  ref={chk1000}
                  onChange={onChange}
                />
                <label className="form-check-label py-1">1000</label>
              </div>
            </fieldset>
          </div>
          <div className="col-md-5">
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Interes Mora
              </legend>
              <div className="form-check col-md-2 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="tipointeres"
                  name="tipointeres"
                  value={1}
                  defaultChecked={values.tipointeres === 1 ? true : false}
                  ref={chkFijo}
                  onChange={onChange}
                />
                <label className="form-check-label py-1">Fijo</label>
              </div>

              <input
                type="text"
                class="form-control col-md-3 mr-3 text-right"
                ref={txtPorcenInt}
                name="porcentajeinteres"
                disabled={disabledInt}
                defaultValue={
                  values
                    ? values.porcentajeinteres !== null
                      ? formatMoneda(
                          values.porcentajeinteres
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )
                      : ""
                    : ""
                }
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                onChange={onChange}
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
                onFocus={seleccionarCampo}
              />

              <div className="form-check col-md-4 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="tipointeres"
                  name="tipointeres"
                  value={2}
                  defaultChecked={values.tipointeres === 2 ? true : false}
                  ref={chkSegun}
                  onChange={onChange}
                />
                <label className="form-check-label py-1 ">Según Tasa</label>
              </div>
            </fieldset>
          </div>
          <div className="col-md-3 ">
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded ">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Declara Web
              </legend>
              <div className="form-check col-md-3 mx-auto mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="declaraweb"
                  name="declaraweb"
                  value={true}
                  defaultChecked={values.declaraweb === true ? true : false}
                  ref={chkDwebsi}
                  onChange={onChange}
                />
                <label className="form-check-label py-1">Si</label>
              </div>
              <div className="form-check col-md-3 mx-auto mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="declaraweb"
                  name="declaraweb"
                  value={false}
                  defaultChecked={values.declaraweb === false ? true : false}
                  ref={chkDwebno}
                  onChange={onChange}
                />
                <label className="form-check-label py-1">No</label>
              </div>
            </fieldset>
          </div>
          <div className="col-md-4">
            <fieldset className=" row mt-2 py-3 col-sm-12 mx-auto border-azul rounded ">
              <span className="col-md-6">Recargos por Mora</span>
              <input
                type="text"
                class="form-control col-md-5 mr-3 text-right"
                aria-label="Sizing example input"
                name="porcentajerecargo"
                defaultValue={
                  values
                    ? values.porcentajerecargo !== ""
                      ? formatMoneda(
                          values.porcentajerecargo
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )
                      : ""
                    : ""
                }
                aria-describedby="inputGroup-sizing-sm"
                ref={txtRecargo}
                onChange={onChange}
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
                onFocus={seleccionarCampo}
              />
            </fieldset>
          </div>
          <div className="col-md-7">
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded pl-3">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Factor para el Cálculo de la Multa
              </legend>
              <div className="form-check col-md-4 mx-auto mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factormulta"
                  name="factormulta"
                  value={1}
                  defaultChecked={values.factormulta === 1 ? true : false}
                  ref={chkk1}
                  onChange={onChange}
                />
                <label className="form-check-label ">Bolivares(Bs.)</label>
              </div>
              <div className="form-check col-md-5 mx-auto mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factormulta"
                  name="factormulta"
                  value={2}
                  defaultChecked={values.factormulta === 2 ? true : false}
                  ref={chkk2}
                  onChange={onChange}
                />
                <label className="form-check-label ">
                  Unidades Tributarias
                </label>
              </div>
              <div className="form-check col-md-2 mx-auto mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factormulta"
                  name="factormulta"
                  value={5}
                  defaultChecked={values.factormulta === 5 ? true : false}
                  ref={chkk5}
                  onChange={onChange}
                />
                <label className="form-check-label ">UCAMP</label>
              </div>
              <div className="form-check col-md-4 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factormulta"
                  name="factormulta"
                  value={4}
                  defaultChecked={values.factormulta === 4 ? true : false}
                  ref={chkk4}
                  onChange={onChange}
                />
                <label className="form-check-label ">Sueldo Minimo</label>
              </div>
              <div className="form-check col-md-5 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factormulta"
                  name="factormulta"
                  value={3}
                  defaultChecked={values.factormulta === 3 ? true : false}
                  ref={chkk3}
                  onChange={onChange}
                />
                <label className="form-check-label ">Unidad Contable</label>
              </div>
              <div className="form-check col-md-2 mx-auto">
                <input
                  className="form-check-input"
                  type="radio"
                  id="factormulta"
                  name="factormulta"
                  value={6}
                  defaultChecked={values.factormulta === 6 ? true : false}
                  ref={chkk6}
                  onChange={onChange}
                />
                <label className="form-check-label ">Otros</label>
              </div>
            </fieldset>
          </div>

          <div className="col-md-3 ">
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded ">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Calcula Minimo
              </legend>
              <div className="form-check col-md-3 mx-auto mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="calculaminimo"
                  name="calculaminimo"
                  value={true}
                  defaultChecked={values.calculaminimo === true ? true : false}
                  ref={chkMininsi}
                  onChange={onChange}
                />
                <label className="form-check-label py-1">Si</label>
              </div>
              <div className="form-check col-md-3 mx-auto mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  id="calculaminimo"
                  name="calculaminimo"
                  value={false}
                  defaultChecked={values.calculaminimo === false ? true : false}
                  ref={chkMininno}
                  onChange={onChange}
                />
                <label className="form-check-label py-1">No</label>
              </div>
            </fieldset>
          </div>

          <div class="input-group input-group-sm mb-2 col-md-2 mt-2 pt-4 pb-4">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Valor:
            </span>
            <input
              type="text"
              class="form-control text-right"
              name="valormulta"
              aria-label="Sizing example input"
              defaultValue={
                values
                  ? values.valormulta !== ""
                    ? formatMoneda(
                        values.valormulta.replace(",", "").replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              onFocus={seleccionarCampo}
              aria-describedby="inputGroup-sizing-sm"
              ref={txtValor}
              onChange={onChange}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={catalogoPer}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/configuracionesDeModulos/modalConfigProduc.js